/* =============================================================
   coss-toolbar.js — Purplle-style mobile bottom nav toolbar
   ============================================================= */

(function () {
  'use strict';

  /* ----------------------------------------------------------
     State
  ---------------------------------------------------------- */
  var activePanel      = null;   // 'categories' | 'brands' | null
  var catStack         = [];     // [{el, title}]
  var openingPanel     = false;  // guard against rapid double-tap race
  var _catResetTimer   = null;   // handle for deferred catReset — cancelled if panel reopens
  var _levelHideTimer  = null;   // handle for deferred level hide (catPush/catPop)
  var _pendingHide     = null;   // element waiting to be hidden after slide-out animation
  var _savedScrollY    = 0;      // saved scroll position for iOS body-scroll lock
  var _bodyLocked      = false;  // body scroll lock state
  var _vpRafId         = null;   // rAF handle for syncBarToViewport debounce

  /* ----------------------------------------------------------
     Element refs (resolved after DOM ready)
  ---------------------------------------------------------- */
  var el = {
    catPanel:        null,
    brandsPanel:     null,
    catBack:         null,
    catTitle:        null,
    brandSearch:     null,
    brandsList:      null,
  };

  /* ----------------------------------------------------------
     Panel open / close
  ---------------------------------------------------------- */

  /* ----------------------------------------------------------
     Account mini-dropdown
  ---------------------------------------------------------- */

  function toggleAccountDrop(trigger) {
    var drop = document.getElementById('cs-tb-acct-drop');
    if (!drop) return;

    if (!drop.hidden) {
      closeAccountDrop();
      return;
    }

    // Close any open panel first
    if (activePanel) closeAll();

    // Position above the trigger button
    var rect = trigger.getBoundingClientRect();
    drop.hidden = false;

    var dropW = drop.offsetWidth;
    var dropH = drop.offsetHeight;

    // Align right edge with trigger right edge, clamped to viewport
    var right = window.innerWidth - rect.right;
    if (right < 8) right = 8;
    if (right + dropW > window.innerWidth - 8) right = window.innerWidth - dropW - 8;

    var bottom = window.innerHeight - rect.top + 8;

    drop.style.right  = right + 'px';
    drop.style.bottom = bottom + 'px';
    drop.style.left   = '';

    trigger.setAttribute('aria-expanded', 'true');
    trigger.classList.add('cs-tb__tab--active');

    // Close on outside click
    var outsideHandler = function (e) {
      if (!drop.contains(e.target) && !trigger.contains(e.target)) {
        closeAccountDrop();
        document.removeEventListener('click', outsideHandler, true);
      }
    };
    drop._outsideHandler = outsideHandler;
    setTimeout(function () {
      document.addEventListener('click', outsideHandler, true);
    }, 0);
  }

  function closeAccountDrop() {
    var drop = document.getElementById('cs-tb-acct-drop');
    if (!drop || drop.hidden) return;
    drop.hidden = true;
    if (drop._outsideHandler) {
      document.removeEventListener('click', drop._outsideHandler, true);
      drop._outsideHandler = null;
    }
    var trigger = document.querySelector('[data-cs-tb-account]');
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      trigger.classList.remove('cs-tb__tab--active');
    }
  }

  function openPanel(name) {
    // Close account dropdown if open
    closeAccountDrop();

    // Toggle: tap same tab again → close
    if (activePanel === name) {
      closeAll();
      return;
    }

    // Guard: ignore rapid double-tap that would fight the close animation
    if (openingPanel) return;
    openingPanel = true;
    setTimeout(function () { openingPanel = false; }, 350);

    // Cancel any pending deferred catReset from a recent close
    if (_catResetTimer) {
      clearTimeout(_catResetTimer);
      _catResetTimer = null;
    }

    // Close any currently-open panel instantly (no transition for a swap)
    if (activePanel) {
      // Reset categories immediately when leaving it via panel-switch
      if (activePanel === 'categories') catReset();

      var prevPanel = document.getElementById('cs-tb-' + activePanel);
      if (prevPanel) {
        prevPanel.classList.remove('cs-tb__panel--open');
        prevPanel.hidden = true;
      }
    }

    // Always start categories at L1 (defence-in-depth)
    if (name === 'categories') catReset();

    activePanel = name;

    var panel = document.getElementById('cs-tb-' + name);
    if (!panel) return;

    panel.hidden = false;

    // Allow paint before adding transition class
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        panel.classList.add('cs-tb__panel--open');
      });
    });

    lockBodyScroll();
    updateTabActive(name);
  }

  function closeAll() {
    if (!activePanel) return;

    var panel          = document.getElementById('cs-tb-' + activePanel);
    var wasCategories  = activePanel === 'categories';

    if (panel) {
      panel.classList.remove('cs-tb__panel--open');
    }

    var closingPanel = panel;
    activePanel = null;

    // Defer hiding + catReset until slide-out animation finishes.
    // Use a cancellable timer — if the panel reopens before it fires,
    // openPanel() clears this timer so catReset doesn't wipe a live session.
    if (_catResetTimer) clearTimeout(_catResetTimer);
    _catResetTimer = setTimeout(function () {
      _catResetTimer = null;
      if (closingPanel) closingPanel.hidden = true;
      if (wasCategories) catReset();
    }, 310);

    unlockBodyScroll();
    updateTabActive(null);
  }

  /* ----------------------------------------------------------
     Active tab highlighting
  ---------------------------------------------------------- */

  function updateTabActive(openName) {
    var tabs = document.querySelectorAll('.cs-tb__tab[data-cs-tb-open]');
    tabs.forEach(function (tab) {
      var tabName  = tab.getAttribute('data-cs-tb-open');
      var isActive = tabName === openName;
      tab.classList.toggle('cs-tb__tab--active', isActive);
      tab.setAttribute('aria-expanded', isActive ? 'true' : 'false');
    });

    // Home: active when at root and no panel is open
    var homeTab = document.querySelector('.cs-tb__tab--home');
    if (homeTab) {
      homeTab.classList.toggle('cs-tb__tab--active', window.location.pathname === '/' && !openName);
    }

    // Cart: never receives the active colour
    var cartTab = document.querySelector('.cs-tb__tab--cart');
    if (cartTab) cartTab.classList.remove('cs-tb__tab--active');
  }

  /* ----------------------------------------------------------
     Category drill-down
  ---------------------------------------------------------- */

  function catReset() {
    // Cancel any pending hide timer and immediately hide the element
    if (_levelHideTimer) {
      clearTimeout(_levelHideTimer);
      _levelHideTimer = null;
    }
    if (_pendingHide) {
      _pendingHide.hidden = true;
      _pendingHide = null;
    }

    // Hide every level
    var allLevels = document.querySelectorAll('#cs-tb-categories .cs-tb__cat-level');
    allLevels.forEach(function (lvl) {
      lvl.hidden = true;
      lvl.classList.remove('cs-active', 'cs-anim-fwd', 'cs-anim-back', 'cs-leaving', 'cs-leaving-back');
    });

    // Show L1
    var l1 = document.querySelector('#cs-tb-categories .cs-tb__cat-level[data-level="1"]');
    if (l1) {
      l1.hidden = false;
      l1.classList.add('cs-active');
    }

    catStack = [];

    // Back button: visible at L1 (tapping it closes the panel)
    if (el.catBack) {
      el.catBack.hidden = false;
    }
    if (el.catTitle) {
      el.catTitle.textContent = 'Categories';
    }
  }

  function catPush(nextEl, title) {
    if (!nextEl) return;

    var currentEl    = document.querySelector('#cs-tb-categories .cs-tb__cat-level.cs-active');
    var currentTitle = el.catTitle ? el.catTitle.textContent : 'Categories';

    catStack.push({ el: currentEl, title: currentTitle });

    // Cancel any pending hide timer — immediately hide the waiting element
    if (_levelHideTimer) {
      clearTimeout(_levelHideTimer);
      _levelHideTimer = null;
      if (_pendingHide) {
        _pendingHide.hidden = true;
        _pendingHide.classList.remove('cs-leaving', 'cs-leaving-back');
        _pendingHide = null;
      }
    }

    // Slide current out (forward)
    if (currentEl) {
      currentEl.classList.remove('cs-active', 'cs-anim-fwd', 'cs-anim-back');
      currentEl.classList.add('cs-leaving');
      var oldEl = currentEl;
      _pendingHide = oldEl;
      _levelHideTimer = setTimeout(function () {
        _levelHideTimer = null;
        _pendingHide = null;
        oldEl.classList.remove('cs-leaving');
        oldEl.hidden = true;
      }, 250);
    }

    // Slide next in (forward) — reset scroll so level starts at top
    nextEl.hidden = false;
    nextEl.scrollTop = 0;
    requestAnimationFrame(function () {
      nextEl.classList.remove('cs-leaving', 'cs-leaving-back', 'cs-anim-fwd', 'cs-anim-back');
      nextEl.classList.add('cs-active', 'cs-anim-fwd');
    });

    if (el.catTitle) el.catTitle.textContent = title;

    // Back button always visible (never hidden once in a panel)
    if (el.catBack) el.catBack.hidden = false;
  }

  function catPop() {
    // At L1 with empty stack → close the whole panel
    if (catStack.length === 0) {
      closeAll();
      return;
    }

    var prev      = catStack.pop();
    var currentEl = document.querySelector('#cs-tb-categories .cs-tb__cat-level.cs-active');

    // Cancel any pending hide timer — immediately hide the waiting element
    if (_levelHideTimer) {
      clearTimeout(_levelHideTimer);
      _levelHideTimer = null;
      if (_pendingHide) {
        _pendingHide.hidden = true;
        _pendingHide.classList.remove('cs-leaving', 'cs-leaving-back');
        _pendingHide = null;
      }
    }

    // Slide current out (backward)
    if (currentEl) {
      currentEl.classList.remove('cs-active', 'cs-anim-fwd', 'cs-anim-back');
      currentEl.classList.add('cs-leaving-back');
      var oldEl = currentEl;
      _pendingHide = oldEl;
      _levelHideTimer = setTimeout(function () {
        _levelHideTimer = null;
        _pendingHide = null;
        oldEl.classList.remove('cs-leaving-back');
        oldEl.hidden = true;
      }, 250);
    }

    // Slide previous in (backward)
    if (prev.el) {
      prev.el.hidden = false;
      prev.el.scrollTop = 0;
      prev.el.classList.remove('cs-leaving', 'cs-leaving-back', 'cs-anim-fwd', 'cs-anim-back');
      requestAnimationFrame(function () {
        prev.el.classList.add('cs-active', 'cs-anim-back');
      });
    }

    if (el.catTitle) el.catTitle.textContent = prev.title;

    // Back button stays visible at L1 (tapping it will close panel via catPop → closeAll)
    if (el.catBack) el.catBack.hidden = false;
  }

  /* ----------------------------------------------------------
     Brand search
  ---------------------------------------------------------- */

  function handleBrandSearch(query) {
    query = query.toLowerCase().trim();

    var groups = document.querySelectorAll('#cs-tb-brands-list .cs-tb__brand-group');
    groups.forEach(function (group) {
      var items        = group.querySelectorAll('.cs-tb__brand-item');
      var visibleCount = 0;

      items.forEach(function (item) {
        var brandName = (item.getAttribute('data-brand') || item.textContent || '').toLowerCase();
        var match     = !query || brandName.indexOf(query) !== -1;
        item.hidden   = !match;
        if (match) visibleCount++;
      });

      group.hidden = visibleCount === 0;
    });
  }

  /* ----------------------------------------------------------
     A-Z scroll (Bug fix: scroll the brands list, not the panel body)
  ---------------------------------------------------------- */

  function scrollToLetter(letter) {
    var targetGroup = document.getElementById('cs-tb-brand-' + letter);
    if (!targetGroup || !el.brandsList) return;

    var listTop   = el.brandsList.getBoundingClientRect().top;
    var groupTop  = targetGroup.getBoundingClientRect().top;
    var offset    = groupTop - listTop + el.brandsList.scrollTop;

    el.brandsList.scrollTop = offset;

    // Briefly highlight the tapped A-Z button
    var btns = document.querySelectorAll('.cs-tb__brand-az-btn');
    btns.forEach(function (btn) { btn.classList.remove('cs-tb__brand-az-btn--active'); });

    var activeBtn = document.querySelector('.cs-tb__brand-az-btn[data-cs-az="' + letter + '"]');
    if (activeBtn) {
      activeBtn.classList.add('cs-tb__brand-az-btn--active');
      setTimeout(function () { activeBtn.classList.remove('cs-tb__brand-az-btn--active'); }, 600);
    }
  }

  /* ----------------------------------------------------------
     Delegated click handler
  ---------------------------------------------------------- */

  function handleClick(e) {
    var target = e.target;

    /* ── Toolbar account dropdown: logout ── */
    var logoutItem = target.closest ? target.closest('.cs-tb__acct-drop-item--logout') : null;
    if (logoutItem) {
      e.preventDefault();
      if (typeof window.csKwikLogout === 'function') {
        window.csKwikLogout();
      } else {
        // window.csKwikLogout only exists where header-v2.liquid renders (not on
        // pages like cs-account layout) — fall back to a self-contained logout.
        try { if (typeof window.handleLogout === 'function') window.handleLogout(); } catch (ex) {}
        ['KWIKSESSIONTOKEN','KWIKUSERTOKEN','ELRTOKEN','kp-request-id','kp_user_id','kp_email','kp_customer_state','kp_customer_id','KP_MERCHANT_CONFIG'].forEach(function(k){try{localStorage.removeItem(k);}catch(ex){}});
        try { Object.keys(localStorage).forEach(function(k){ if(/kp_|kwik|_ka_/i.test(k)) { try{localStorage.removeItem(k);}catch(ex){} } }); } catch(ex) {}
        ['kp_valid_session','KP_CUSTOMER_EMAIL_DATA','kp_meta_landing_referrer','KP_MARKETING_POPUP_INFO','kp_session_type'].forEach(function(k){try{sessionStorage.removeItem(k);}catch(ex){}});
        try { Object.keys(sessionStorage).forEach(function(k){ if(/kp_|kwik|_ka_/i.test(k)) { try{sessionStorage.removeItem(k);}catch(ex){} } }); } catch(ex) {}
        var hn = location.hostname;
        document.cookie.split(';').forEach(function(c){
          var name = c.split('=')[0].trim();
          if (!name || !/kp_|kwik|_ka_/i.test(name)) return;
          document.cookie = name+'=;Max-Age=0;path=/;';
          document.cookie = name+'=;Max-Age=0;path=/;domain=.'+hn+';';
          document.cookie = name+'=;Max-Age=0;path=/;domain='+hn.replace(/^www\./,'')+';';
          document.cookie = name+'=;Max-Age=0;path=/;domain=.'+hn.replace(/^www\./,'')+';';
        });
        window.location.href = '/';
      }
      return;
    }

    /* ── Account mini-dropdown ── */
    var acctTrigger = target.closest ? target.closest('[data-cs-tb-account]') : null;
    if (acctTrigger) {
      var kwikLoggedIn = (localStorage.getItem('KWIKSESSIONTOKEN') || '').trim() !== '' &&
                         sessionStorage.getItem('kp_valid_session') === 'true';
      var shopifyLoggedIn = acctTrigger.getAttribute('data-cs-logged-in') === '1';
      if (!kwikLoggedIn && !shopifyLoggedIn) {
        e.preventDefault();
        function _fireKwikPopup() {
          try { sessionStorage.removeItem('kp_valid_session'); } catch(ex) {}
          try { document.cookie = 'kp_user_id=;Max-Age=0;path=/;'; document.cookie = 'kp_user_id=;Max-Age=0;path=/;domain=.' + location.hostname + ';'; } catch(ex) {}
          var lnk = document.createElement('a');
          lnk.href = '/account/login';
          lnk.style.display = 'none';
          document.body.appendChild(lnk);
          lnk.click();
          document.body.removeChild(lnk);
        }
        if (typeof window.kp_trigger_popup === 'function') {
          _fireKwikPopup();
        } else {
          // Kwik sso.js not yet loaded — poll up to 8s
          var _pa = 0;
          var _pp = setInterval(function() {
            _pa++;
            if (typeof window.kp_trigger_popup === 'function') { clearInterval(_pp); _fireKwikPopup(); }
            else if (_pa >= 40) { clearInterval(_pp); window.location.href = '/account/login'; }
          }, 200);
        }
        return;
      }
      toggleAccountDrop(acctTrigger);
      return;
    }

    /* ── Open panel tab ── */
    var openTrigger = target.closest ? target.closest('[data-cs-tb-open]') : null;
    if (openTrigger) {
      var panelName = openTrigger.getAttribute('data-cs-tb-open');
      openPanel(panelName);
      return;
    }

    /* ── Close (X button) ── */
    var closeTrigger = target.closest ? target.closest('[data-cs-tb-close]') : null;
    if (closeTrigger) {
      closeAll();
      return;
    }

    /* ── Back button ── */
    var backTrigger = target.closest ? target.closest('[data-cs-tb-back]') : null;
    if (backTrigger) {
      catPop();   // closes panel when stack is empty (at L1)
      return;
    }

    /* ── Category tile / row ── */
    var catTrigger = target.closest ? target.closest('[data-cs-cat]') : null;
    if (catTrigger) {
      var hasChildren = catTrigger.getAttribute('data-cs-cat-children') === '1';
      var catUrl      = catTrigger.getAttribute('data-cs-cat-url');
      var catTitle    = catTrigger.getAttribute('data-cs-cat-title');
      var catLevel    = parseInt(catTrigger.getAttribute('data-cs-cat-level'), 10);
      var catIdx      = catTrigger.getAttribute('data-cs-cat-idx');
      var catParent   = catTrigger.getAttribute('data-cs-cat-parent');

      if (hasChildren) {
        var nextEl;

        if (catLevel === 1) {
          nextEl = document.querySelector(
            '#cs-tb-categories .cs-tb__cat-level[data-level="2"][data-parent="' + catIdx + '"]'
          );
        } else if (catLevel === 2) {
          var l3Id = catTrigger.getAttribute('data-cs-cat-l3-id');
          nextEl = l3Id ? document.getElementById(l3Id) : null;
        }

        if (nextEl) {
          catPush(nextEl, catTitle);
        } else if (catUrl) {
          window.location.href = catUrl;
        }
      } else if (catUrl) {
        window.location.href = catUrl;
      }

      return;
    }

    /* ── A-Z sidebar button ── */
    var azBtn = target.closest ? target.closest('[data-cs-az]') : null;
    if (azBtn && !azBtn.disabled) {
      scrollToLetter(azBtn.getAttribute('data-cs-az'));
      return;
    }
  }

  /* ----------------------------------------------------------
     Keyboard handler
  ---------------------------------------------------------- */

  function handleKeydown(e) {
    if (e.key === 'Escape') closeAll();
  }

  /* ----------------------------------------------------------
     Init
  ---------------------------------------------------------- */

  /* ----------------------------------------------------------
     iOS body-scroll lock
     document.body.overflow='hidden' doesn't stop scroll on iOS Safari.
     Instead we fix body to viewport and restore scroll position on unlock.
  ---------------------------------------------------------- */

  function lockBodyScroll() {
    if (_bodyLocked) return;
    _savedScrollY = window.pageYOffset || 0;
    document.body.style.position   = 'fixed';
    document.body.style.top        = '-' + _savedScrollY + 'px';
    document.body.style.width      = '100%';
    document.body.style.overflowY  = 'scroll'; // keep scrollbar width stable on desktop
    _bodyLocked = true;
  }

  function unlockBodyScroll() {
    if (!_bodyLocked) return;
    document.body.style.position  = '';
    document.body.style.top       = '';
    document.body.style.width     = '';
    document.body.style.overflowY = '';
    window.scrollTo(0, _savedScrollY);
    _bodyLocked = false;
  }

  /* ----------------------------------------------------------
     Visual-viewport compensation
     iOS Chrome "bottom address bar" and Safari bottom toolbar
     sit on top of position:fixed elements. We push the bar up
     by however much of the layout viewport the browser chrome
     is occupying at the bottom.
     Uses rAF debounce to avoid reflow on every resize event.
  ---------------------------------------------------------- */

  function syncBarToViewport() {
    if (_vpRafId) return; // already scheduled this frame
    _vpRafId = requestAnimationFrame(function () {
      _vpRafId = null;
      if (!window.visualViewport) return;
      var vv     = window.visualViewport;
      var offset = Math.max(0, window.innerHeight - vv.offsetTop - vv.height);
      // Cap at 120px — keyboards are typically 260px+, we only want browser chrome
      if (offset > 120) offset = 0;
      document.documentElement.style.setProperty('--cs-bar-bottom', offset + 'px');
    });
  }

  function init() {
    el.catPanel      = document.getElementById('cs-tb-categories');
    el.brandsPanel   = document.getElementById('cs-tb-brands');
    el.catBack       = document.querySelector('#cs-tb-categories [data-cs-tb-back]');
    el.catTitle      = document.querySelector('#cs-tb-categories .cs-tb__panel-title');
    el.brandSearch   = document.querySelector('#cs-tb-brands .cs-tb__brand-search');
    el.brandsList    = document.getElementById('cs-tb-brands-list');

    // Delegated events
    document.addEventListener('click', handleClick, { passive: false });
    document.addEventListener('keydown', handleKeydown);

    // Brand search
    if (el.brandSearch) {
      el.brandSearch.addEventListener('input', function () {
        handleBrandSearch(this.value);
      });
    }

    // Visual viewport: keep bar above iOS/Chrome browser chrome
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', syncBarToViewport);
    }
    syncBarToViewport();

    catReset();
    updateTabActive(null);
    applyCustomCatImages();
  }

  /* ----------------------------------------------------------
     Custom Level-1 category images
     window.csTbCatImgs is populated by sections/cs-toolbar-categories.liquid
     keyed by collection handle → image URL
     Bug fix: targets .cs-tb__cat-banner and img.cs-tb__cat-banner-img
  ---------------------------------------------------------- */

  function applyCustomCatImages() {
    var map = window.csTbCatImgs;
    if (!map) return;

    document.querySelectorAll('.cs-tb__cat-banner[data-cs-cat-handle]').forEach(function (banner) {
      var handle = banner.getAttribute('data-cs-cat-handle');
      if (!handle || !map[handle]) return;

      var src = map[handle];

      var img = banner.querySelector('img.cs-tb__cat-banner-img');
      if (!img) {
        var placeholder = banner.querySelector('.cs-tb__cat-banner-placeholder');
        img = document.createElement('img');
        img.className = 'cs-tb__cat-banner-img';
        img.loading   = 'lazy';
        if (placeholder) {
          placeholder.parentNode.replaceChild(img, placeholder);
        } else {
          banner.insertBefore(img, banner.firstChild);
        }
      }

      img.src = src;
      img.alt = banner.getAttribute('data-cs-cat-title') || '';
    });
  }

  /* ----------------------------------------------------------
     Boot
  ---------------------------------------------------------- */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
